import {contractTypes} from "$lib/utils/templating/contractTypes";
import OpenButton from "$lib/components/ui/OpenButton.svelte";
import RemoveButton from "$lib/components/ui/RemoveButton.svelte";
import AddButton from "$lib/components/ui/AddButton.svelte";
import EditButton from "$lib/components/ui/EditButton.svelte";


export const contractTemplates = (deleteFunction: Function, editFunction: Function, newVersionFunction: Function) =>  ([
    {
        label: 'Type',
        property: 'contractType',
        render: (contract:any) => contractTypes.find(x => x.value === contract.contractType)?.name
    },
    {
        label: 'Name',
        property: 'name'
    },
    {
        label: 'Edit',
        property: 'id',
        component: EditButton,
        props: {
            onClick: (id:number) => {
                editFunction(id)
            }
        }
    },
    {
        label: 'New Version',
        property: 'id',
        component: EditButton,
        props: {
            onClick: (id:number) => {
                newVersionFunction(id)
            }
        }
    },
    {
        label: 'Download',
        property: 'location',
        component: OpenButton,
        props: {
            onClick: (loc:string) => window ? window.open(loc,'_blank')?.focus() : null
        },

    },
    {
        label: 'Entfernen',
        property: 'id',
        component: RemoveButton,
        props: {
            onClick: (id:number) => {
                deleteFunction(id)
            }
        }
    }
])